/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */


import React, { memo } from 'react';
import { FlickityWrapper } from '../flickity-wrapper';
import NumberFormat from '../../utils/number-format';
import ClampLines from 'react-clamp-lines';


export interface Bubble {
  _id: string;
  name: string;
  allowDelete?: boolean;
  suffix?: string;
  target?: number;
  actual?: number;
}

interface Props {
  bubbles: Bubble[],
  removeUTrConfirmation?: (id: string) => void;
  isManager?: boolean;
  loadUTrModal: (id: string) => void;
}

export const Bubbles = memo(({ bubbles, isManager, loadUTrModal, removeUTrConfirmation }: Props) => {

  if (bubbles.length === 0) {
    return <div style={{ height: 130 }} />;
  }

  return (
    <FlickityWrapper disableImagesLoaded={true} reloadOnUpdate={true} options={{
      cellAlign: 'left',
      pageDots: true,
      draggable: true,
      groupCells: true,
    }}>
      {bubbles.map((bubble, i) => {

        return (
          <div className='target-actual-container' key={`${bubble._id}-${i}`}>
            {isManager && removeUTrConfirmation && bubble.allowDelete && <div className='removeButton' onClick={() => removeUTrConfirmation(bubble._id)}>
              <i className='fa fas fa-times' />
            </div>
            }

            <div className='position-relative ml-3 text-center target-actual-outer'>

              <div className='target-actual'>
                <div className='target-actual-inner'>
                  <span
                    className='target-actual-header'>TARGET</span>
                  <span className='target-actual-figure'>
                    <NumberFormat
                      suffix={bubble.suffix}
                      value={bubble.target}
                      decimalPlaces={0}
                      abbreviate={true} />
                  </span>
                </div>
              </div>

              <div className='target-actual'>
                <div className='target-actual-inner'>
                  <span
                    className='target-actual-header'>LATEST</span>
                  <span className='target-actual-figure'>
                    <NumberFormat
                      suffix={bubble.suffix}
                      value={bubble.actual}
                      decimalPlaces={0}
                      abbreviate={true} />
                  </span>
                </div>
              </div>

              <div className='link-like mt-2' onClick={() => bubble._id && loadUTrModal(bubble._id)}>
                <ClampLines id={bubble.name + '-' + i} text={bubble.name ?? ''}
                  lines={2} moreText='' lessText=''
                  ellipsis='...' />
              </div>
            </div>
          </div>
        )
      }
      )}
    </FlickityWrapper>
  );
});
